export const locale = {
  lang: 'en',
  data: {
    INVOICE: {
      UPLOAD_INVOICE: 'Upload invoice',
      EDIT_INVOICE: 'Edit invoice',
      INVOICES: 'Invoices Draft',
      DEBTOR: 'Debtor',
      NUMBER_INVOICE: 'N.&nbsp;Invoice',
      AMOUNT: 'Amount',
      TOTAL: 'Total',
      DUE_DATE: 'Due Date',
      MINIMUM_BID: 'Minimum Bid',
      STATUS: 'Status',
      REFRESH: 'Refresh',
      NEW: 'Load invoice Extra Ue or Bucket',
      XML: 'LOAD ELECTRONIC INVOICE XML',
      UPLOAD_XML: 'Upload XML invoices',
      DROP_ZONE_LABEL: 'Drag and drop XML files here or click to upload',
      STATUSES: {
        DRAFT: 'Draft',
        SENT: 'Sent',
      },
      EDIT: 'Edit',
      ATTACH: 'Attachments',
      SEND: 'Send',
      DELETE: 'Delete',
      PUBLISH_DIALOG: {
        TITLE: 'Accept the terms of service to publish the invoice',
        DESCRIPTION: 'Accetta le condizioni di servizio',
        TOS_1: 'Confermo di conoscere e accetto i',
        TOS_1_LINK: '"Termini e Condizioni di Utilizzo della Piattaforma"',
        TOS_2: 'Confermo di conoscere e accetto le seguenti',
        TOS_2_LINK: '"Condizioni della Cessione"',
        CANCEL: 'Cancel',
        PUBLISH: 'Publish',
        SUCCESS: 'Invoice has been successfully sent to CashMe and it is available in your Sent section.',
      },
      ERROR_DIALOG: {
        TITLE: 'Warning',
        MESSAGE: 'There was an error sending the invoice. Check the following data:',
        MESSAGE_PROFILE: 'It is not possible to publish the invoice, enter the missing data in the Profile section on the left.',
      },
      DELETE_DIALOG: {
        TITLE: 'Confirm',
        DESCRIPTION: 'Do you want to delete this invoice?',
        CANCEL: 'Cancel',
        OK: 'Confirm',
        SUCCESS: 'Invoice deleted correctly.',
      },
      SNACKBAR: {
        DEBTOR_ADDED: 'Debtor added successfully!',
        INVOICE_ADDED: 'Invoice added successfully!',
        INVOICE_EDITED: 'Invoice edited successfully!',
        ADDED: 'Invoice added successfully!',
        DELETED: 'Invoice deleted successfully!',
        NOT_DELETED: 'Error: invoice not deleted!',
        ATTACHMENT_ERROR: 'Error uploading file',
        ERROR: 'Error: retry!',
        ATTACHMENT: 'You must upload at least one XML invoice and all other mandatory document',
        DUE_DATE: 'You must enter an due date after tomorrow',
        ACTIVATED: 'You must be enabled by the CashMe team to be able to publish an invoice',
      },
      XML_OR_P7M_ONLY: 'Only XML or P7M files are accepted.',
    },
  },
};
